/* global URL_WEBSOCKET_MONITOR, ENABLE_MONITORING */
import { useEffect } from 'react';
import io from 'socket.io-client';

export const useActiveUserSocket = () => {
  useEffect(() => {
    // Si el monitoreo está deshabilitado, no hacer nada
    if (!ENABLE_MONITORING) {
      return;
    }

    const URL = URL_WEBSOCKET_MONITOR || '';

    if (!URL) {
      return;
    }

    const socket = io(URL);

    socket.on('connect', () => {
      socket.emit('subscribe', 'panel_session');
    });

    return () => {
      if (socket.connected) {
        socket.emit('unsubscribe', 'panel_session');
      }
      socket.off('connect');
      socket.disconnect();
    };
  }, []);
};
